<template>
  <ion-row>
    <ion-col size-md="12" size-lg="12">
      <ion-row>
        <ion-col size="2">
          <PersonalizeProgress :current-step="1" :total-steps="4" />
        </ion-col>
        <ion-col size="10">
          <h3 class="h3 text-color-body">{{ t('personalize.cityTitle') }}</h3>
        </ion-col>
      </ion-row>
      <p class="text-color-body text-align-left text-sm">{{ t('personalize.cityDescription') }}</p>
      <div class="mt-lg">
        <CustomInput
          form-name="personalize"
          type="text"
          :value="personalizeForm.city"
          v-model="personalizeForm.city"
          input-type="searchMap"
          :label="t('personalize.labels.city')"
          name="city"
          class-name="custom-field"
          placeholder="Madrid"
          :icon="homeOutline"
        />
      </div>
    </ion-col>
  </ion-row>
</template>
<script setup lang="ts">
  import { homeOutline } from 'ionicons/icons';
  import { IonCol, IonRow } from '@ionic/vue';
  import { useI18n } from 'vue-i18n';
  import CustomInput from '@/components/shared/form/CustomInput.vue';
  import { usePersonalize } from '@/composables/usePersonalize';
  import PersonalizeProgress from '@/components/personalize/PersonalizeProgress.vue';

  const { t } = useI18n();
  const { personalizeForm } = usePersonalize();
</script>
<style scoped lang="scss"></style>
